export default __webpack_public_path__ + "static/media/hhvn2024-logo.af16db83.png";